import { render } from "./DiscoveryGrid.vue?vue&type=template&id=4d5c05f6"
import script from "./DiscoveryGrid.vue?vue&type=script&lang=js"
export * from "./DiscoveryGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__